/**
 * Marketplace API Service
 */

import { BaseApiService } from '@metlas/shared';
import type { ApiResponse, MarketplaceQuestionResponse } from '../types';

class MarketplaceApiService extends BaseApiService {
  constructor() {
    super('Marketplace');
  }

  async askQuestion(message: string): Promise<ApiResponse<MarketplaceQuestionResponse>> {
    return this.post<ApiResponse<MarketplaceQuestionResponse>>('/api/v1/cu-marketplace/chat', {
      message,
    });
  }

  async rateQuality(
    id: string,
    isRelevant?: boolean,
    researcherNotes?: string
  ): Promise<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/cu-marketplace/rate-quality', {
      id,
      is_relevant: isRelevant,
      researcher_notes: researcherNotes,
    });
  }
}

export const marketplaceApiService = new MarketplaceApiService();
